// USER REDUCER TYPES
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED'
export const SET_TOUR_COMPLETED = 'SET_TOUR_COMPLETED'
export const SET_USER = 'SET_USER'
export const SET_USER_NOTIFICATIONS = 'SET_USER_NOTIFICATIONS'
export const SIGN_IN_USER = 'SIGN_IN_USER'
export const SIGN_UP_USER = 'SIGN_UP_USER'
export const SET_USER_UNCONFIRMED = 'SET_USER_UNCONFIRMED'
export const SET_FORGOT_PASSWORD = 'SET_FORGOT_PASSWORD'
export const SET_RESET_PASSWORD_SENT = 'SET_RESET_PASSWORD_SENT'
export const LOADING_USER = 'LOADING_USER'
export const CHANGE_USER_DETAILS = 'CHANGE_USER_DETAILS'
export const UPDATING_USER = 'UPDATING_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const CHANGING_PASSWORD = 'CHANGING_PASSWORD'
export const MARK_NOTIFICATIONS_READ = 'MARK_NOTIFICATIONS_READ'
export const UPDATE_TOKENS = 'UPDATE_TOKENS'
export const LOADING_OTHER_USER = 'LOADING_OTHER_USER'
export const SET_OTHER_USER = 'SET_OTHER_USER'
// SPORT REDUCER TYPES
export const SET_SPORT = 'SET_SPORT'
export const SET_GAMEWEEK = 'SET_GAMEWEEK'
export const SET_SEASON = 'SET_SEASON'
// GAMES REDUCER TYPES
export const LOADING_GAMES = 'LOADING_GAMES'
export const SET_GAMES = 'SET_GAMES'
export const LOADING_GAME = 'LOADING_GAME'
export const SET_GAME = 'SET_GAME'
export const LOADING_GAME_PREDICTION = 'LOADING_GAME_PREDICTION'
export const SET_GAME_PREDICTION = 'SET_GAME_PREDICTION'
export const TOGGLE_ODDS_CHART_TYPE = 'TOGGLE_ODDS_CHART_TYPE'
export const SET_ODDS_MOVEMENT = 'SET_ODDS_MOVEMENT'
export const LOADING_ODDS_MOVEMENT = 'LOADING_ODDS_MOVEMENT'
export const SET_SPORTSBOOKS = 'SET_SPORTSBOOKS'
// PREDICTIONS REDUCER
export const LOADING_PREDICTIONS = 'LOADING_PREDICTIONS'
export const LOADING_GROUP_PREDICTIONS = 'LOADING_GROUP_PREDICTIONS'
export const LOADING_COMPARED_USER_PREDICTIONS = 'LOADING_COMPARED_USER_PREDICTIONS'
export const SET_PREDICTIONS = 'SET_PREDICTIONS'
export const SET_GROUP_PREDICTIONS = 'SET_GROUP_PREDICTIONS'
export const SET_COMPARED_USER_PREDICTIONS = 'SET_COMPARED_USER_PREDICTIONS'
export const CHANGE_GAME_SCORE = 'CHANGE_GAME_SCORE'
export const CHANGE_GAME_STAKES = 'CHANGE_GAME_STAKES'
export const SUBMITTING_PREDICTION = 'SUBMITTING_PREDICTION'
export const SUBMITTED_PREDICTION = 'SUBMITTED_PREDICTION'
export const GETTING_COMPARED_USER_PREDICTIONS = 'GETTING_COMPARED_USER_PREDICTIONS'
export const SUBMITTING_SURVIVOR_PICK = 'SUBMITTING_SURVIVOR_PICK'
export const SUBMITTED_SURVIVOR_PICK = 'SUBMITTED_SURVIVOR_PICK'
export const SET_SURVIVOR_PICK_ERROR = 'SET_SURVIVOR_PICK_ERROR'
export const CLEAR_SURVIVOR_PICK_ERROR = 'CLEAR_SURVIVOR_PICK_ERROR'
export const SUBMITTING_TEASER = 'SUBMITTING_TEASER'
export const SUBMITTED_TEASER = 'SUBMITTED_TEASER'
export const SET_TEASER_ERROR = 'SET_TEASER_ERROR'
export const CLEAR_TEASER_ERROR = 'CLEAR_TEASER_ERROR'
// LEADERBOARD REDUCER TYPES
export const LOADING_LEADERBOARDS = 'LOADING_LEADERBOARDS'
export const SET_LEADERBOARDS = 'SET_LEADERBOARDS'
export const SELECT_LEADERBOARD_TYPE = 'SELECT_LEADERBOARD_TYPE'
export const LOADING_CROWD_RESULTS = 'LOADING_CROWD_RESULTS'
export const SET_CROWD_RESULTS = 'SET_CROWD_RESULTS'
// GROUPS REDUCER TYPES
export const LOADING_GROUPS = 'LOADING_GROUPS'
export const LOADING_GROUP = 'LOADING_GROUP'
export const SET_GROUPS = 'SET_GROUPS'
export const SET_GROUP = 'SET_GROUP'
export const UPDATE_GROUP = 'UPDATE_GROUP'
export const SELECT_GROUP_SEASON = 'SELECT_GROUP_SEASON'
export const JOIN_GROUP = 'JOIN_GROUP'
export const JOINING_GROUP = 'JOINING_GROUP'
export const LEAVE_GROUP = 'LEAVE_GROUP'
export const CREATE_GROUP = 'CREATE_GROUP'
export const CREATING_GROUP = 'CREATING_GROUP'
export const DELETE_GROUP = 'DELETE_GROUP'
// UI REDUCER TYPES
export const SET_ERRORS = 'SET_ERRORS'
export const LOADING_UI = 'LOADING_UI'
export const STOP_LOADING_UI = 'STOP_LOADING_UI'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const TOGGLE_LOGIN_MODAL = 'TOGGLE_LOGIN_MODAL'
export const TOGGLE_LEAVE_GROUP_MODAL = 'TOGGLE_LEAVE_GROUP_MODAL'
export const TOGGLE_CREATE_GROUP_MODAL = 'TOGGLE_CREATE_GROUP_MODAL'
export const TOGGLE_ODDS_CHANGE_MODAL = 'TOGGLE_ODDS_CHANGE_MODAL' 
export const TOGGLE_HOW_TO_PLAY_MODAL = 'TOGGLE_HOW_TO_PLAY_MODAL'
export const ON_CHANGE_TEXT = 'ON_CHANGE_TEXT'
// WAGERS TYPES
export const LOADING_WAGERS = 'LOADING_WAGERS'
export const SET_WAGERS = 'SET_WAGERS'
export const ADD_WAGER = 'ADD_WAGER'
export const LOADING_ODDS = 'LOADING_ODDS'
export const SET_GAME_ODDS = 'SET_GAME_ODDS'